const GUARANTEE_RETURNS_PAGE_SIZE = 200;

export { GUARANTEE_RETURNS_PAGE_SIZE };
